import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import './CardPVZ.scss';
import './CardPVZ-media.scss';
import { Props } from './interfaces';

const CardPVZ = ({ city, time, address }: Props) => {
  return (
    <div className="card-pvz">
      <h4>{city}</h4>
      <p>{time}</p>
      <p className="body2 card-pvz__address">{address}</p>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(CardPVZ));
